import ShopifyCart from "../services/shopify-cart";
import cartDrawer from "../components/cart-drawer-state";
import { getAllVariantDataObjectsFromUrl } from "../utils/inputs";
import { getCorrectVariantFromOptionsOrNull } from "@surf-turf/nemo/assets/utils-product";
import { listenForVariantOptionsChanges } from "@surf-turf/nemo/assets/utils-events";

class ProductForm extends HTMLElement {
  constructor() {
    super();

    // This refers to the ProductForm element.
    const form = this.querySelector("form");

    const allFieldsetElements = form.querySelectorAll("fieldset");
    const productVariantIdElement = form.querySelector(
      'input[name="productVariant"]'
    );
    const variantDataJson = form.querySelector("#variants-data");
    const allVariants = variantDataJson
      ? JSON.parse(variantDataJson.innerHTML).variants
      : null;
    const addToCartButton = this.querySelector("#addToBagButton");

    /**
     * Attach listener to the form submit buttons.
     *
     * @param event {object}
     *
     * @returns {boolean}
     */



    const handleAddToCart = async (event) => {
      const formData = Object.fromEntries(new FormData(event.target).entries());

      // Check if engraving is typed.
      if (formData.engraving == "") {
        event.preventDefault();
        event.target.reportValidity();
        return false;
      }

      // Check if initial is chosen.
      if (formData.initial == "") {
        event.preventDefault();
        event.target.reportValidity();
        return false;
      }

      // Check if variant id is set and the form is valid (all required fields are entered).
      if (formData.productVariant) {
        // Loop over form data keys to check if there is a connected product.
        const allFormDataKeys = Object.keys(formData);
        const allConnectedProducts = allFormDataKeys.filter((dataElement) =>
          dataElement.includes("connectedProductVariantId")
        );

        if (allConnectedProducts.length > 0) {
          await ShopifyCart.addMultiple(formData, addToCartButton);
          cartDrawer.openCartDrawer();
        } else {
          // Submit to Shopify add to cart.
          await ShopifyCart.add(formData, addToCartButton);
          cartDrawer.openCartDrawer();
        }
      } else {
        // addButton.setMakeSelection()
      }
    };

    const handleStockCheck = (correctVariantObject) => {
      // Create array of the selected products
      const selectedVariants = correctVariantObject.connectedProducts;
      selectedVariants.push(correctVariantObject.mainProduct);

      // Reset the form on each change.
      handleAddToCartButtonState(true);

      // Send the variants to the estimated shipping widget
      handleEstimatedShippingDate(selectedVariants);

      // Check if the selected variants are available to purchase.
      selectedVariants.find((variant) => {
        if (variant) {
          if (
            variant.inventory_policy === "deny" &&
            variant.inventory_quantity < 1
          ) {
            handleAddToCartButtonState(false);
            // Send all variants to the set variants for Klaviyo
            setOutOfStockVariants(selectedVariants);
            document.querySelector("estimated-shipping").style.display = "none";
          } else {
            document.querySelector("estimated-shipping").style.display =
              "block";
          }
        }
      });
    };

    const setOutOfStockVariants = (variants) => {
      const variantElement = document.querySelector(
        `back-in-stock input[name="variant"]`
      );
      const outOfStockVariants = [];

      variants.filter((variant) => {
        if (variant) {
          if (variant.inventory_quantity < 1) {
            outOfStockVariants.push(variant.id);
          }
        }
      });

      if (variantElement) {
        variantElement.value = outOfStockVariants;
      }
    };

    const handleAddToCartButtonState = (state) => {
      if (state === true) {
        addToBagButton.disabled = false;
      } else {
        addToBagButton.disabled = true;
      }
    };

    const handleEstimatedShippingDate = (selectedVariants) => {
      const lowestStock = selectedVariants.reduce(function (prev, curr) {
        return prev.inventory_quantity < curr.inventory_quantity ? prev : curr;
      });

      const estimatedShippingDate = document.querySelector(
        ".product-usps estimated-shipping"
      );
      if (estimatedShippingDate) {
        estimatedShippingDate.dataset.stock = lowestStock?.inventory_quantity;
        estimatedShippingDate.dataset.stockIncreasedThreshold =
          lowestStock?.stock_threshold;

        const event = new Event("changeDateInput");
        estimatedShippingDate.dispatchEvent(event);
      }
    };


    listenForVariantOptionsChanges(() => {

      const correctVariantObject = getAllVariantDataObjectsFromUrl();

      if (correctVariantObject?.mainProduct) {
        productVariantIdElement.value = correctVariantObject?.mainProduct.id;
      }

      handleStockCheck(correctVariantObject);
    });

    if (form) {
      form.addEventListener("submit", (event) => {
        // Prevent going to the add to cart page.
        event.preventDefault();

        handleAddToCart(event);
      });
    }
  }
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get("product-form") === undefined) {
  customElements.define("product-form", ProductForm);
}
